import { ReactElement } from "react";
import styles from "../../ContactInformation/ContactInformation.module.css";
import { useProfileContextData } from "pages/employer-of-record/employee-profile/contexts/ProfileInfoContext";
import { formatPhoneNumber } from "pages/employer-of-record/employee-profile/utils";
import Row from "pages/employer-of-record/employee-profile/components/Row/Row";

export default function EmergencyContact(): ReactElement {
  const { profileInfo } = useProfileContextData();
  const emergencyContact =
    profileInfo?.eorEmployeeProfile.personalInfo?.emergencyContact;
  const workCountry: string =
    profileInfo?.eorEmployeeProfile?.employment?.workCountry || "";
  const phoneNumber = formatPhoneNumber(
    emergencyContact?.phoneNumber?.value,
    workCountry
  );

  const hasEmergencyContact =
    emergencyContact?.firstName &&
    emergencyContact?.lastName &&
    emergencyContact?.relationship;

  return (
    <>
      <Row label="Emergency contact" required>
        {hasEmergencyContact ? (
          <div className={styles.boxWrapper}>
            <Row
              boldValue
              value={`${emergencyContact?.firstName} ${emergencyContact?.lastName}`}
              tag={emergencyContact?.relationship || ""}
            />
            <Row
              value={phoneNumber}
              tag={emergencyContact?.phoneNumber?.type || ""}
            />
          </div>
        ) : undefined}
      </Row>
    </>
  );
}
